<div class="displayFlexRow booking-details-wrapper ">
  <div class="details-stops displayFlexColumn">
    <div class="details mb-16">
      <div class="detail-wrapper displayFlexRow">
        <div style="width: 10%;">
          <div >
            <span class="fs-12 font-weight-400 geoaraea-label">Date</span>
            <div class="detail-info">{{booking.startTime | dateTimeConverter}}</div>
          </div>
        </div>
        <ng-container *ngFor="let field of config">
          <div class=" ml-20" style="width: '10%';"
            *ngIf="booking[field.elementKey] && field.elementKey!=='guardReq' && field.elementKey!=='reason'">
            <label class=""><span class="fs-12 font-weight-400 geoaraea-label">{{field.config.displayName}}</span></label>
            <div class="detail-info" *ngIf="field.elementKey != 'vendor'">
              {{booking[field.elementKey] | booleanConverter}}
            </div>
            <div class="detail-info" *ngIf="field.elementKey == 'vendor'">
              {{booking[field.elementKey].vendorName || booking[field.elementKey]}}
            </div>
          </div>
        </ng-container>

        <div class="ml-20" style="width: 10%;">
          <label ><span class="fs-12 font-weight-400 geoaraea-label">Marshall Needed</span></label>
          <div class="detail-info">
            {{booking.guardReq? 'Yes' : 'No'}}
          </div>
        </div>
        <div class="ml-20" style="width: 10%;" *ngIf="booking.reason!=''">
          <label ><span class="fs-12 font-weight-400 geoaraea-label">Comments</span></label>
          <div class="detail-info">
            {{booking.reason}}
          </div>
        </div>
      </div>
      <img [src]="expandView ?'assets/Collapse.svg':'assets/Expand.svg' " (click)="toggleBooking()"  alt="toggle-btn" class="toggleroute-btn"  matTooltip="View Details" matTooltipClass="booking-table-tooltip" />

    </div>
    <div class="rider-details displayFlexRow" *ngIf="expandView">
      <div class="stops" *ngIf="!isMultiDayBooking" style="width: 80%;">
        <div class="stop-table">
          <div class="stop-table-header displayFlex">
            <div class="header rider-column ">Passenger Details</div>
            <div class="header address-column">Address Details</div>
          </div>
          <div class="table-body">
            <div class="stop-table-row" *ngFor="let rider of uniqueRiderArray;let i=index;"
              [ngStyle]="i==uniqueRiderArray.length-1? {'margin-bottom':'0', 'border-bottom':'none','padding-bottom':'0'}:{}">
              <div class="rider displayFlexColumn">
                <div class="fs-14 font-weight-700 mb-4 color-181F33">{{rider.name}} <span *ngIf="rider.emplId" class="color-181F33 fs-12 font-weight-700">({{rider.emplId}})</span>
                </div>
                <div class="fs-12 geoaraea-label mb-2 rider-email" matTooltip="{{rider.email}}">{{rider.email}}</div>
                <div class="fs-12 geoaraea-label">
                  <span class="fs-12 font-weight-400 geoaraea-label">{{(rider?.mobile | formatPhoneNumber : rider) || '--'}}</span>
                  <span class="ml-12 mr-12 ellipseSeparator"><img src="assets/images/EllipseSeparator.svg"></span>
                  <span class="fs-12 font-weight-400 geoaraea-label">{{rider?.costCenter || '--'}}</span>
                </div>
              </div>
              <div class="stop displayFlexRow">
                <div class="time mr-12">{{rider.time | twelvehourtimeformatter}}</div>
                <div class="address displayFlexColumn">
                  <div style="border-left: 2px dashed #6A737D ; padding: 0 0 24px 12px;" class="displayFlex fs-12"> <img src="assets/start_address.svg" class="startImages">{{rider.startAddress}}</div>
                  <div style="padding-left: 12px; display: flex;" > <img src="assets/end_address.svg" alt="" class="stopImages fs-12 " style="right: 19px;"> {{rider.endAddress}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- -----multiday  -->
      <div *ngIf="isMultiDayBooking" class="displayFlex" style="width: 80%;">
        <div class="rider-box mr-16">
          <div class="fs-14 font-weight-400 multi-label">Passenger Details</div>
          <div class="rider-details">
            <div *ngFor="let rider of uniqueRiderArray;let i=index;">
              <div class="displayFlexColumn" [ngClass]="i==uniqueRiderArray.length-1 ? '':'last-rider'">
                <div class="fs-14 font-weight-700 mb-4 color-181F33">{{rider.name}} <span *ngIf="rider.emplId" class="color-181F33 fs-12 font-weight-700">({{rider.emplId}})</span>
                </div>
                <div class="fs-12 geoaraea-label mb-2">{{rider.email}}</div>
                <div class="fs-12 geoaraea-label">
                  <span class="fs-12 font-weight-400 geoaraea-label">{{(rider?.mobile | formatPhoneNumber : rider) || '--'}}</span>
                  <span class="ml-12 mr-12 ellipseSeparator"><img src="assets/images/EllipseSeparator.svg"></span>
                  <span class="fs-12 font-weight-400 geoaraea-label">{{rider?.costCenter || '--'}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- //route  -->
        <app-requester-details [requester]="requester" [paymentType]="requester.paymentType" [booking]="[booking]" [miscellConfig]="miscellConfig" [escortConfig]="escortConfig"></app-requester-details>
        <div class="riders">
          <div class="mb-12">
            <span class="fs-14 font-weight-700 color-181F33">Your Route</span>
            <img [src]="expandRoute ?'assets/caret-up-large.svg':'assets/caret-down-large.svg'" (click)="expandRoute=!expandRoute"  alt="toggle-btn"  style="float: right;" class="toggleroute-btn"  matTooltip="View Details" matTooltipClass="booking-table-tooltip" />
          </div>
    
          <div *ngIf="stopsDetails.length>0 && expandRoute" class="trip-content displayFlexColumn">
            <ng-container *ngFor="let stop of stopsDetails; let i=index;">
                <div [ngClass]=" stop.pointType == 'END' ? 'endRoute' : 'route' ">
                    <span class="stopImages2">
                        <img
                            [src]=" stop.pointType == 'START' ? 'assets/ic-ui-location1.svg' : stop.pointType == 'END' ? 'assets/ic-location2.svg' : 'assets/ic-ui-seperator.svg'"
                            alt="stopTypeImg">
                    </span>
                    <div [ngClass]="stop.pointType == 'END'? 'endRouteData' : 'routeData' ">
                        <span *ngIf="stopsDetails[i]['time'] && stopsDetails[i]['time'] != ''" class="boxedContent">
                            {{stopsDetails[i]['time'] | twelvehourtimeformatter}} </span>
                        <span class="routeAddress fs-12">{{stopsDetails[i]['address']}}</span>
                        <span class="landmark" *ngIf="stopsDetails[i]['geoArea']"> {{stopsDetails[i]['geoArea'] | titlecase}} </span>
                    </div>
                </div>
            </ng-container>
        </div>
        <div class="multi-address">
          <div class="fs-14 font-weight-400 multi-label">Multi-day Stops</div>
            <div class=" displayFlexColumn" style="padding: 24px 16px 16px;">
              <div class=" displayFlexColumn" *ngFor="let day of multidayTrips; let dayIndex=index">
                <div class="displayFlex " *ngFor="let stop of day.stops; let stopIndex=index">
                  <div style="width: 72px;"> <div *ngIf="stopIndex==0" class="dayCount">Day-{{day.day}}</div></div>
                  <div style="width: 52px;"> <div class="boxedContent" *ngIf="dayIndex==0 && stopIndex==0">{{stop.time}}</div></div>
                 
                  <div class="displayFlex align-item-center" [ngStyle]="(dayIndex==multidayTrips.length-1 && stopIndex==day.stops.length-1) ?{'left': '16px','bottom': '4px'} : {'border-left':'2px dashed #6A737D', 'padding-bottom':'24px'}">
                    <span><img [ngStyle]="(dayIndex==multidayTrips.length-1 && stopIndex==day.stops.length-1) ? {'right':'7px','bottom':'2px'} : (dayIndex==0 && stopIndex==0) ? {'right':'9px','bottom':'2px'} : {'right':'11px','bottom':'2px'} " class="position-relative " 
                       [src]="(dayIndex==multidayTrips.length-1 && stopIndex==day.stops.length-1) ?  'assets/end_address.svg' : (dayIndex==0 && stopIndex==0) ? 'assets/start_address.svg' :  'assets/ic-ui-seperator-16-sm.svg'  " alt=""></span>
                    <div class="ml-12">{{stop.address}}</div> 
                  </div>
                </div>
             </div>
            </div>
        </div>
      </div>
    </div>
      <div class="comment-riders displayFlexColumn ml-24">
        <div *ngIf="estimatedResponse" class="estimateData displayFlexSpaceBetween mb-12 ">
          <div class="displayFlexColumn" *ngIf="estimatedResponse?.totalEstimatedDistance">
            <span class="fs-10 geoaraea-label">Estimated Kms</span> <span class="fs-14 font-weight-700">{{((estimatedResponse?.totalEstimatedDistance)/1000).toFixed(2) || '--'}} kms</span>
          </div>
          <div class="displayFlexColumn" *ngIf="estimatedResponse?.totalEstimatedTime">
            <span class="fs-10 geoaraea-label">Estimated Time</span> <span class="fs-14 font-weight-700">{{((estimatedResponse?.totalEstimatedTime)/60).toFixed(2) || '--'}} hrs</span>
          </div>
          <div class="displayFlexColumn" *ngIf="estimatedResponse?.totalEstimatedCost">
            <span class="fs-10 geoaraea-label">Estimated Cost</span> <span class="fs-14 font-weight-700">Rs. {{estimatedResponse?.totalEstimatedCost || '--'}}</span>
          </div>
        </div>
        <app-requester-details [requester]="requester" [paymentType]="requester.paymentType" [booking]="[booking]" [miscellConfig]="miscellConfig" [escortConfig]="escortConfig" ></app-requester-details>
        <!-- Recoverable Type -->
        <div *ngIf="miscellConfig?.verifyEngagementCode" class="recoverable-box displayFlexColumn mb-10">
          <div class="displayFlexColumn padding-all-16">
            <div class="fs-12 font-weight-400 label-color-929DAB mb-2">Recoverable Type</div>
            <div class="fs-14 font-weight-400 color-181F33">{{booking?.billableType || '--'}}</div>
            <ng-container *ngIf="booking?.manager">
              <div class="fs-12 font-weight-400 label-color-929DAB mb-2 mt-12">Reporting Manager</div>
              <div class="fs-14 font-weight-400 color-181F33">{{booking.manager.name || '--'}} ({{booking.manager.id || '--'}})</div>
            </ng-container>
            <ng-container *ngIf="booking?.partner">
              <div class="fs-12 font-weight-400 label-color-929DAB mb-2 mt-12">Partner</div>
              <div class="fs-14 font-weight-400 color-181F33">{{booking.partner.name || '--'}} ({{booking.partner.id || '--'}})</div>
            </ng-container>
          </div>
        </div>
        <div class="riders" (click)="openMap()">
          <div class=" displayFlexRow align-item-center">
            <span>
              <img src="assets/eye_icon.svg" alt="" class="mr-8 mt-4">
            </span>
            <span class="text-primary fs-14 font-weight-700">
              View Your Route 
            </span>
          </div>
        </div>
      </div>
  </div>
</div>

<app-popover *ngIf="openRouteMap" size="full" titleText="Your Route" (closeCallback)="openRouteMap=false">
  <div popover-content class="displayFlexRow">
    <div class="map-section">
      <div id="map-container">
      </div>
    </div>
    <div class="route-box">
      <div *ngFor="let stop of stopsDetails; let i=index;">
        <div [ngClass]=" stop.pointType == 'END' ? 'endRoute' : 'route' ">
            <span class="stopImages2">
                <img
                    [src]=" stop.pointType == 'START' ? 'assets/ic-ui-location1.svg' : stop.pointType == 'END' ? 'assets/ic-location2.svg' : 'assets/ic-ui-seperator.svg'"
                    alt="stopTypeImg">
            </span>
            <div [ngClass]="stop.pointType == 'END'? 'endRouteData' : 'routeData' ">
                <span *ngIf="stopsDetails[i]['time'] && stopsDetails[i]['time'] != ''" class="boxedContent">
                    {{stopsDetails[i]['time'] | twelvehourtimeformatter}} </span>
                <span class="routeAddress fs-12">{{stopsDetails[i]['address']}}</span>
                <span class="landmark" *ngIf="stopsDetails[i]['geoArea']"> {{stopsDetails[i]['geoArea'] | titlecase}} </span>
            </div>
        </div>
      </div>
    </div>
  </div>
</app-popover>